"use strict";

exports.__esModule = true;
exports.PointsExchangeClient = void 0;
var _http = require("@tajawal/web-core-sdk-v2/lib/services/http.service");
var _client = require("@tajawal/web-core-sdk-v2/lib/utils/client.utils");
var _constants = require("../constants");
const headers = {
  'product-type': 'points-exchange'
};
const PointsExchangeClient = {
  getAmounts(source, target, displayType) {
    const endPoint = (0, _client.replaceParams)(_constants.ENDPOINTS.GET_POINTS_EXCHANGE_PRODUCTS, {
      source,
      target,
      displayType
    });
    const requestId = 'GET_POINTS_EXCHANGE_AMOUNTS';
    return _http.$http.get(requestId, endPoint, {
      headers,
      params: {
        source,
        target,
        displayType
      }
    }).then(({
      data
    }) => data);
  },
  getProductById(amount, source, target, productId, displayType) {
    const endPoint = (0, _client.replaceParams)(_constants.ENDPOINTS.GET_POINTS_EXCHANGE_PRODUCT, {
      amount,
      source,
      target,
      productId,
      displayType
    });
    const requestId = 'GET_POINTS_EXCHANGE_PRODUCT';
    return _http.$http.get(requestId, endPoint, {
      headers,
      params: {}
    }).then(({
      data
    }) => data);
  },
  createSale(productId, displayType, amount, captchaToken) {
    const config = {
      headers: {
        ...headers,
        'x-captcha-token': captchaToken
      },
      data: {
        product: {
          id: productId,
          displayType,
          amount
        }
      }
    };
    const requestId = 'POINTS_EXCHANGE_CREATE_SALE';
    return _http.$http.post(requestId, _constants.ENDPOINTS.POINTS_EXCHANGE_CREATE_SALE, config).then(({
      data
    }) => data);
  },
  requestOtp(saleId, identifier, method, captchaToken) {
    const endPoint = (0, _client.replaceParams)(_constants.ENDPOINTS.POINTS_EXCHANGE_INIT_REDEEM, {
      saleId
    });
    const config = {
      headers,
      data: {
        method,
        identifier,
        captchaToken
      }
    };
    const requestId = 'POINTS_EXCHANGE_INIT_REDEEM';
    return _http.$http.post(requestId, endPoint, config).then(({
      data
    }) => data);
  },
  checkout(code, email, saleId, otpToken, saleTotal, sourceMethod, targetMethod, captchaToken, sourceIdentifier, targetIdentifier) {
    const endPoint = (0, _client.replaceParams)(_constants.ENDPOINTS.POINTS_EXCHANGE_CHECKOUT, {
      saleId
    });
    const config = {
      headers,
      data: {
        payment: {
          loyalty: {
            identifier: sourceIdentifier,
            code,
            otpToken
          },
          method: sourceMethod
        },
        loyaltyReward: {
          identifier: targetIdentifier,
          method: targetMethod
        },
        contact: {
          email
        },
        total: saleTotal,
        captchaToken
      }
    };
    const requestId = 'POINTS_EXCHANGE_CHECKOUT';
    return _http.$http.post(requestId, `/api/checkout/sale/${saleId}/checkout`, config).then(({
      data
    }) => data);
  },
  checkWalletBalance() {
    const requestId = 'GET_WALLET_CHECK_BALANCE';
    return _http.$http.get(requestId, _constants.ENDPOINTS.GET_WALLET_CHECK_BALANCE, {
      headers
    }).then(({
      data
    }) => data);
  },
  getAllowedProviders() {
    const requestId = 'POINTS_EXCHANGE_ALLOWED_PROVIDERS';
    return _http.$http.get(requestId, _constants.ENDPOINTS.POINTS_EXCHANGE_ALLOWED_PROVIDERS, {
      headers
    }).then(({
      data
    }) => data);
  }
};
exports.PointsExchangeClient = PointsExchangeClient;